/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {
    UPDATE_FORM_DATA,
    UPDATE_MULTIPLE_FORM_FIELDS,
    ACTIVATE_FIELD,
    DEACTIVATE_FIELD
} from 'state/actions/embedsState/embedManagementState/form_data';



/* ========== ~~~~~~~~~~ FORM DATA : REDUCER ~~~~~~~~~~ ========== */
// REDUCER
// used to manipulate application state
// takes an action, checks its type, based on that performs certain functionality, then returns new slice of state
// utilized in "_container" components
const defaultState = {
    website: { active: false, value: '', valid: null },
    embedname: { active: false, value: '', valid: null }
};

const formData = (state=defaultState, action) => {
    switch (action.type) {
        case UPDATE_FORM_DATA:
            let newState = JSON.parse(JSON.stringify(state));
            // newState[action.field].active = action.active;
            newState[action.field].value = action.value;
            newState[action.field].valid = action.valid;
            return newState;
        case UPDATE_MULTIPLE_FORM_FIELDS:
            // console.log("@@@ SETTING UPDATE_MULTIPLE_FORM_FIELDS @@@@", action);
            newState = JSON.parse(JSON.stringify(state));
            newState = action.formData !== null ? Object.assign({}, newState, action.formData) : newState;
            return newState;
        case ACTIVATE_FIELD:
            newState = JSON.parse(JSON.stringify(state));
            newState[action.field].active = true;
            return newState;
        case DEACTIVATE_FIELD:
            newState = JSON.parse(JSON.stringify(state));
            newState[action.field].active = false;
            newState[action.field].valid = null;
            return newState;
        default:
            return state;
    }
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default formData;